import { render } from "./Home.vue?vue&type=template&id=13ed1228&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=13ed1228&lang=css"
import "./Home.vue?vue&type=style&index=1&id=13ed1228&scoped=true&lang=css"

import exportComponent from "/home/runner/work/internal-docs/internal-docs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ed1228"]])

export default __exports__